import React from 'react';
import './Modal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar, PieChart, Pie, Cell } from 'recharts';

const Modal = ({ show, onClose, chartData, chartType, isDarkMode, categoryReport, getScoreDistribution, getWeeklyProgress }) => {
  if (!show) {
    return null;
  }

  const renderChart = () => {
    const tooltipStyle = {
      backgroundColor: isDarkMode ? '#0f2132' : '#fff',
      color: isDarkMode ? '#ffffff' : '#333',
      border: isDarkMode ? '1px solid #2c5282' : '1px solid #ddd'
    };

    const axisProps = {
      axisLine: false,
      tickLine: false,
      tick: { fill: isDarkMode ? '#ffffff' : '#2c3e50' }
    };

    const gridColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

    switch (chartType) {
      case 'accuracy':
        return (
          <>
            <h3>Performance Trend - Expanded</h3>
            <ResponsiveContainer width="100%" height="85%">
              <LineChart data={chartData}>
                <CartesianGrid stroke={gridColor} />
                <XAxis dataKey="name" {...axisProps} />
                <YAxis {...axisProps} />
                <Tooltip contentStyle={tooltipStyle} />
                <Line type="monotone" dataKey="accuracy" stroke="#10b981" strokeWidth={3} name="Accuracy %" />
              </LineChart>
            </ResponsiveContainer>
          </>
        );

      case 'volume':
        return (
          <>
            <h3>Daily Study Volume - Expanded</h3>
            <ResponsiveContainer width="100%" height="85%">
              <LineChart data={chartData}>
                <CartesianGrid stroke={gridColor} />
                <XAxis dataKey="name" {...axisProps} />
                <YAxis yAxisId="questions" {...axisProps} />
                <YAxis yAxisId="time" orientation="right" {...axisProps} />
                <Tooltip contentStyle={tooltipStyle} />
                <Line yAxisId="questions" type="monotone" dataKey="totalQuestions" stroke="#3b82f6" strokeWidth={2} name="Questions" />
                <Line yAxisId="time" type="monotone" dataKey="studyTime" stroke="#f59e0b" strokeWidth={2} name="Study Time (min)" />
              </LineChart>
            </ResponsiveContainer>
          </>
        );      case 'distribution':
        return (
          <>
            <h3>Score Distribution - Expanded</h3>
            <ResponsiveContainer width="100%" height="85%">
              <BarChart data={getScoreDistribution ? getScoreDistribution() : []}>
                <CartesianGrid stroke={gridColor} />
                <XAxis dataKey="range" {...axisProps} />
                <YAxis {...axisProps} />
                <Tooltip contentStyle={tooltipStyle} />
                <Bar dataKey="count" fill="#8b5cf6" name="Days" />
              </BarChart>
            </ResponsiveContainer>
          </>
        );      case 'weekly':
        return (
          <>
            <h3>Weekly Progress - Expanded</h3>
            <ResponsiveContainer width="100%" height="85%">
              <BarChart data={getWeeklyProgress ? getWeeklyProgress() : []}>
                <CartesianGrid stroke={gridColor} />
                <XAxis dataKey="week" {...axisProps} />
                <YAxis {...axisProps} />
                <Tooltip contentStyle={tooltipStyle} />
                <Bar dataKey="questions" fill="#06b6d4" name="Questions" />
                <Bar dataKey="avgAccuracy" fill="#10b981" name="Avg Accuracy %" />
              </BarChart>
            </ResponsiveContainer>
          </>
        );

      case 'breakdown':
        return (
          <>
            <h3>Correct vs Incorrect - Expanded</h3>
            <ResponsiveContainer width="100%" height="85%">
              <BarChart data={chartData}>
                <CartesianGrid stroke={gridColor} />
                <XAxis dataKey="name" {...axisProps} />
                <YAxis {...axisProps} />
                <Tooltip contentStyle={tooltipStyle} />
                <Bar dataKey="correctAnswers" stackId="a" fill="#10b981" name="Correct" />
                <Bar dataKey="incorrectAnswers" stackId="a" fill="#ef4444" name="Incorrect" />
              </BarChart>
            </ResponsiveContainer>
          </>
        );

      // Legacy support for old chart types
      case 'total':
        return (
          <>
            <h3>Total Questions</h3>
            <ResponsiveContainer width="100%" height="85%">
              <LineChart data={chartData}>
                <CartesianGrid stroke={gridColor} />
                <XAxis dataKey="name" {...axisProps} />
                <YAxis {...axisProps} />
                <Tooltip contentStyle={tooltipStyle} />
                <Line type="monotone" dataKey="total" stroke="#8884d8" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </>
        );

      case 'correct':
        return (
          <>
            <h3>Correct Answers</h3>
            <ResponsiveContainer width="100%" height="85%">
              <LineChart data={chartData}>
                <CartesianGrid stroke={gridColor} />
                <XAxis dataKey="name" {...axisProps} />
                <YAxis {...axisProps} />
                <Tooltip contentStyle={tooltipStyle} />
                <Line type="monotone" dataKey="correct" stroke="#82ca9d" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </>
        );

      case 'incorrect':
        return (
          <>
            <h3>Incorrect Answers</h3>
            <ResponsiveContainer width="100%" height="85%">
              <LineChart data={chartData}>
                <CartesianGrid stroke={gridColor} />
                <XAxis dataKey="name" {...axisProps} />
                <YAxis {...axisProps} />
                <Tooltip contentStyle={tooltipStyle} />
                <Line type="monotone" dataKey="incorrect" stroke="#ff7300" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </>
        );

      default:
        return (
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <h3>Chart Not Available</h3>
            <p>This chart type is not supported in expanded view.</p>
          </div>
        );
    }
  };
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        {renderChart()}
      </div>
    </div>
  );
};

export default Modal;
